import axios, { AxiosResponse } from 'axios';

import { getApiEndPoint } from '../helpers/apibase';
import { mapServerError } from './utils/serverErrorMapper';

export interface BankAccountStatusesRequest {
  brandId: string;
}

export interface BankAccountStatus {
  accountId: string;
  lastPayoutFailed: boolean;
  payoutDetails: Record<string, unknown>;
  externalAccountDetails: Record<string, unknown>;
}

export interface BankAccountStatusesResponse {
  data: BankAccountStatus[];
}

const baseURL = getApiEndPoint();

const businessDetailsApi = axios.create({
  baseURL,
  withCredentials: true,
});

export const getBankAccountStatusesKey = 'getBankAccountStatuses';

export const getBankAccountStatuses = async (
  orgId: string,
  brandId: string
): Promise<BankAccountStatusesResponse> => {
  try {
    const response = await businessDetailsApi.post<
      BankAccountStatusesRequest,
      AxiosResponse<BankAccountStatusesResponse>
    >(`/business-details/orgs/${encodeURIComponent(orgId)}/bank-accounts/statuses`, { brandId });
    return response.data;
  } catch (error) {
    const err = await mapServerError(error);
    throw err;
  }
};
